import React, {ReactNode, useEffect, useState} from 'react';

interface BottomPopupProps {
    show?: boolean;
    children: ReactNode;
    onClose: () => void;
}

const BottomPopup: React.FC<BottomPopupProps> = ({ children, show, onClose }) => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if(show !== undefined) {
            setIsOpen(show);
        }
    }, [show]);

    return (
        <>
            {isOpen && (
                <div className="fixed inset-0 flex md:items-center items-end justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white p-6 rounded-t-3xl md:rounded-lg shadow-lg w-full max-w-[900px] relative">
                        <button onClick={ () => onClose() } className="absolute top-6 right-4 text-2xl">
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd"
                                      d="M23.556 7.55602C23.0651 7.06507 22.2691 7.06507 21.7781 7.55602L16 13.3341L10.2219 7.55597C9.73096 7.06502 8.93498 7.06502 8.44403 7.55597C7.95309 8.04691 7.95309 8.84289 8.44403 9.33383L14.2222 15.112L7.99967 21.3345C7.50872 21.8254 7.50872 22.6214 7.99967 23.1124C8.49061 23.6033 9.28659 23.6033 9.77754 23.1124L16 16.8899L22.2225 23.1123C22.7135 23.6033 23.5094 23.6033 24.0004 23.1123C24.4913 22.6214 24.4913 21.8254 24.0004 21.3344L17.7779 15.112L23.556 9.33388C24.047 8.84294 24.047 8.04696 23.556 7.55602Z"
                                      fill="#BDBDBD"/>
                            </svg>
                        </button>
                        {children}
                    </div>
                </div>
            )}
        </>
    );
};

export default BottomPopup;